module.exports = __webpack_public_path__ + "media/images/twilio-583e72cfffa99db7d4cd789badf13e88.svg";